(function () {
    // ── Total header height: take max bottom across all sticky/header-group elements ──
    function updateTotalHeaderHeight() {
        var candidates = [
            document.querySelector('sticky-header'),
            document.querySelector('.shopify-section-header-sticky')
        ].concat(Array.from(document.querySelectorAll('.shopify-section-group-header-group')));

        var maxBottom = 0;
        candidates.forEach(function (el) {
            if (!el) return;
            var b = el.getBoundingClientRect().bottom;
            if (b > maxBottom) maxBottom = b;
        });

        // Fallback: use header offsetHeight if nothing gave a positive result
        if (maxBottom <= 0) {
            var header = document.querySelector('header');
            if (header) maxBottom = header.offsetHeight;
        }

        document.documentElement.style.setProperty('--bst-total-header-height', maxBottom + 'px');
    }

    // Run after full page load so fonts/images don't shift layout
    window.addEventListener('load', updateTotalHeaderHeight);
    window.addEventListener('resize', updateTotalHeaderHeight);

    // ── Body scroll lock when search is open ─────────────────────────
    function lockBodyScroll() {
        document.body.style.overflow = 'hidden';
    }

    function unlockBodyScroll() {
        document.body.style.overflow = '';
    }

    // Watch predictive-search element for open/close
    function observePredictiveSearch() {
        var ps = document.querySelector('predictive-search');
        if (!ps) return;

        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.attributeName === 'open') {
                    if (ps.hasAttribute('open')) {
                        updateTotalHeaderHeight(); // fresh measurement when search opens
                        lockBodyScroll();
                    } else {
                        unlockBodyScroll();
                    }
                }
            });
        });

        observer.observe(ps, { attributes: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', observePredictiveSearch);
    } else {
        observePredictiveSearch();
    }

    // ── Supplement collections when predictive API returns fewer than 3 ──
    var collectionCache = {};
    var parentLabels = { reha: 'Reha', pflege: 'Pflege', gesundheit: 'Gesundheit', sport: 'Sport', wellness: 'Wellness', koerperzonen: 'Körperzonen' };

    function supplementCollections(term) {
        var section = document.querySelector('.bst-search-section[data-section="collections"]');
        if (!section) return;
        var ul = section.querySelector('ul');
        if (!ul) return;
        var shown = ul.querySelectorAll('li').length;
        if (shown >= 3) return; // already enough

        var url = '/search?q=' + encodeURIComponent(term) + '&type=collection&view=bst-collections';
        var cached = collectionCache[term];
        var doInject = function (items) {
            // Build set of already-shown URLs to avoid duplicates
            var shownUrls = {};
            ul.querySelectorAll('a').forEach(function (a) { shownUrls[a.getAttribute('href').split('?')[0]] = true; });
            var added = 0;
            items.forEach(function (item) {
                if (added + shown >= 5) return;
                var cleanUrl = item.url.split('?')[0];
                if (shownUrls[cleanUrl]) return;
                shownUrls[cleanUrl] = true;
                added++;
                var parts = item.handle.split('-');
                var parent = parentLabels[parts[0]] || '';
                var parentHtml = parent ? '<span class="bst-search-collection-item__parent">' + parent + '</span>' : '';
                var excerptHtml = item.description ? '<p class="bst-search-collection-item__excerpt">' + item.description + '</p>' : '';
                var li = document.createElement('li');
                li.className = 'predictive-search__list-item';
                li.setAttribute('role', 'option');
                li.setAttribute('aria-selected', 'false');
                li.innerHTML = '<a href="' + item.url + '" class="bst-search-collection-item link link--text" tabindex="-1">'
                    + '<div class="bst-search-collection-item__content">'
                    + parentHtml
                    + '<p class="bst-search-collection-item__title">' + item.title + '</p>'
                    + excerptHtml
                    + '<span class="bst-search-collection-item__more">Mehr lesen</span>'
                    + '</div></a>';
                ul.appendChild(li);
            });
        };

        if (cached) { doInject(cached); return; }
        fetch(url).then(function (r) { return r.json(); })
            .then(function (items) { collectionCache[term] = items; doInject(items); })
            .catch(function () {});
    }

    // ── Fetch real total counts via alternate search template ────────
    var countCache = {};
    var typeToTab = { product: 'products', article: 'articles', page: 'pages', collection: 'collections' };

    function fetchRealCounts(term) {
        if (countCache[term]) { applyRealCounts(countCache[term]); supplementCollections(term); return; }

        var types = Object.keys(typeToTab);
        var results = {};
        var remaining = types.length;

        types.forEach(function (type) {
            fetch('/search?q=' + encodeURIComponent(term) + '&type=' + type + '&view=bst-count')
                .then(function (res) { return res.json(); })
                .then(function (data) {
                    results[type] = data.count || 0;
                })
                .catch(function () { results[type] = 0; })
                .finally(function () {
                    remaining--;
                    if (remaining === 0) {
                        countCache[term] = results;
                        applyRealCounts(results);
                        supplementCollections(term);
                    }
                });
        });
    }

    function applyRealCounts(counts) {
        var total = 0;
        Object.keys(counts).forEach(function (type) {
            total += counts[type];
            var tabName = typeToTab[type];
            var tab = document.querySelector('.bst-search-tab[data-tab="' + tabName + '"]');
            if (tab) tab.textContent = tab.textContent.replace(/\(\d+\)/, '(' + counts[type] + ')');
            // Also update the section <h3> title
            var section = document.querySelector('.bst-search-section[data-section="' + tabName + '"]');
            if (section) {
                var title = section.querySelector('.bst-search-section__title');
                if (title) title.textContent = title.textContent.replace(/\(\d+\)/, '(' + counts[type] + ')');
            }
        });
        var allTab = document.querySelector('.bst-search-tab[data-tab="all"]');
        if (allTab) allTab.textContent = allTab.textContent.replace(/\(\d+\)/, '(' + total + ')');
    }

    // Watch for new search results and trigger count fetch
    document.addEventListener('bst-search-rendered', function (e) {
        if (e.detail && e.detail.term) fetchRealCounts(e.detail.term);
    });

    // Observe [data-predictive-search] for content changes to detect new results
    function initCountObserver() {
        var container = document.querySelector('[data-predictive-search]');
        if (!container) return;
        var observer = new MutationObserver(function () {
            var ps = document.querySelector('predictive-search');
            if (!ps || !ps.hasAttribute('open')) return;
            var input = ps.querySelector('input[type="search"]');
            if (input && input.value.length >= 2) fetchRealCounts(input.value);
        });
        observer.observe(container, { childList: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initCountObserver);
    } else {
        initCountObserver();
    }

    // ── Close search ─────────────────────────────────────────────────
    function closeSearch() {
        var ps = document.querySelector('predictive-search');
        if (!ps) return;
        var input = ps.querySelector('input[type="search"]');
        if (input) {
            input.value = '';
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.blur();
        }
        ps.removeAttribute('open');
        unlockBodyScroll();
    }

    // ── Click handler ─────────────────────────────────────────────────
    document.addEventListener('click', function (e) {
        if (e.target.closest('.bst-predictive-close')) {
            closeSearch();
            return;
        }

        var tab = e.target.closest('.bst-search-tab');
        if (!tab) return;

        e.preventDefault();
        e.stopPropagation();

        var resultsEl = tab.closest('#predictive-search-results');
        if (!resultsEl) return;

        var activeTab = tab.dataset.tab;

        resultsEl.querySelectorAll('.bst-search-tab').forEach(function (t) {
            t.classList.toggle('is-active', t === tab);
        });

        resultsEl.querySelectorAll('.bst-search-section').forEach(function
            (section) {
            var show = activeTab === 'all' || section.dataset.section ===
                activeTab;
            section.style.display = show ? '' : 'none';
        });
    });
})();